/**
 * Slugs canônicos das Features.
 *
 * Use SLUGS em vez de FEATURE_IDS para features adicionadas após o launch
 * inicial — IDs auto-increment podem divergir entre ambientes (dev/staging/prod).
 * Slugs são fixados na migration via `slug=...` e servem como chave estável.
 *
 * Pareia com `hasPermissionBySlug(slug, action)` exposto pelo UserContext.
 */
export const FEATURE_SLUGS = {
  RELATORIOS_AVANCADOS: "relatorios_avancados",
};
